import { AssetPermission } from '@deltasierra/frontend-graphql-core';
import { AssetType } from '../constants';
import { Asset, AssetFolder } from '../types';

export const mapAssetFolderToAsset = (assetFolder: AssetFolder, permissions: AssetPermission[]): Asset => {
    const asset: Asset = {
        dateAdded: assetFolder.created,
        expiry: null,
        fileSize: assetFolder.size,
        id: assetFolder.id,
        name: assetFolder.title,
        permissions,
        tags: [],
        type: AssetType.Folder,
    };
    return asset;
};
